/**
 * When sharing a station/segment, we need to make sure certain metadata
 * are sent from the metadata to the page HTML (server-side reactRouterMiddleware.js)
 */
export const RECEIVE_PAGE_METADATA = '@@pageMetadata/RECEIVE_PAGE_METADATA';
export const UPDATE_GOOGLE_BREADCRUMBS_STRUCTURED_DATA =
  '@@pageMetadata/UPDATE_GOOGLE_BREADCRUMBS_STRUCTURED_DATA';

const KEYWORDS = [
  'podcast hosting',
  'free podcast hosting',
  'make a podcast',
  'making a podcast',
  'create a podcast',
  'creating a podcast',
  'podcast sponsorships',
  'sponsor a podcast',
  'free',
  'audio',
  'recording',
  'audio clip',
  'anchor',
  'podcasts',
  'voice',
  'microphone',
  'podcast',
  'podcast creation',
  'record',
  'conversation',
  'discussion',
  'talk',
  'talking',
  'radio',
  'public radio',
  'npr',
  'startup',
  'talk radio',
];

const initialState = {
  description:
    'Create, distribute, host, and monetize your podcast, 100% free.',
  keywords: KEYWORDS.join(','),
  image:
    'https://d12xoj7p9moygp.cloudfront.net/images/social/opengraph-anchorfm.png',
  imageWidth: 1200,
  imageHeight: 630,
  twitterImage:
    'https://d12xoj7p9moygp.cloudfront.net/images/social/opengraph-twitter-anchorfm.png',
  twitterCard: 'summary_large_image',
  facebookType: 'website',
  oEmbedTitle: '',
  oEmbedUrl: '',
  rssFeedTitle: '',
  rssFeedUrl: '',
  campaign: undefined,
  googleBreadcrumbsStructuredData: [],
};

// reducer

// TODO: Add payload to make it consistent with the current way we're structuring
//       our reducers
// eslint-disable-next-line import/no-default-export
export default function reducer(state = initialState, action) {
  switch (action.type) {
    case RECEIVE_PAGE_METADATA: {
      // TODO: metadata => meta middleware.js Flux Standard Action format
      const { metadata } = action;
      // prune any falsy
      Object.keys(metadata).forEach(k => {
        if (!metadata[k]) {
          delete metadata[k];
        }
      });

      // TODO: bad practice: side effect in reducer, but not sure any other best place to do this
      return {
        ...state,
        ...metadata,
      };
    }
    case UPDATE_GOOGLE_BREADCRUMBS_STRUCTURED_DATA: {
      const newState = {
        ...state,
        googleBreadcrumbsStructuredData:
          action.payload.googleBreadcrumbsStructuredData,
      };
      return newState;
    }
    default:
      return state;
  }
}

// action creators

export function receivePageMetadata(metadata) {
  return {
    type: RECEIVE_PAGE_METADATA,
    metadata,
  };
}

export function updateGoogleBreadcrumbsStructuredData(
  googleBreadcrumbsStructuredData
) {
  return {
    type: UPDATE_GOOGLE_BREADCRUMBS_STRUCTURED_DATA,
    payload: {
      googleBreadcrumbsStructuredData,
    },
  };
}
